function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st11{fill:#231F20;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,100C22.4,100,0,77.6,0,50C0,22.4,22.4,0,50,0s50,22.4,50,50C100,77.6,77.6,100,50,100z M50,3.3 C24.3,3.3,3.3,24.3,3.3,50c0,25.7,20.9,46.7,46.7,46.7S96.7,75.7,96.7,50C96.7,24.3,75.7,3.3,50,3.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,63.4c-1.6,0-3.1-0.7-4.1-2l-12-16.2c-1.2-1.5-1.5-3.7-0.6-5.6c0.9-1.8,2.8-3,4.8-3h0.5v-6 c0-1,0.4-2,1.1-2.8l0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.1 c0.2-0.1,0.3-0.1,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.5-0.1,0.8-0.1h15c2.2,0,4,1.8,4,4v6H62c0,0,0,0,0,0 c2.9,0,5.3,2.4,5.3,5.3c0,1.3-0.5,2.6-1.4,3.6L54.2,61.4C53.1,62.7,51.6,63.4,50,63.4z M38,39.5c-0.9,0-1.8,0.5-2.2,1.4 c-0.4,0.8-0.3,1.9,0.3,2.6l12,16.2c0.4,0.5,1.1,0.9,1.9,0.9c0.7,0,1.4-0.3,1.9-0.9l11.8-15.9c0,0,0.1-0.1,0.1-0.1 c0.4-0.5,0.7-1,0.7-1.7c0-1.3-1.1-2.4-2.4-2.4c0,0-0.1,0-0.1,0h-1.9c-0.8,0-1.4-0.6-1.4-1.4v-7.5c0-0.6-0.5-1.2-1.2-1.2h-15 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0l-0.4,0.3c-0.1,0.2-0.3,0.4-0.3,0.8V38c0,0.8-0.6,1.4-1.4,1.4H38z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M65.9,73.4H34.1c-4.2,0-7.6-3.4-7.6-7.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4c0,2.6,2.1,4.8,4.8,4.8 h31.8c2.6,0,4.8-2.1,4.8-4.8c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4C73.5,70,70.1,73.4,65.9,73.4z"
})));

var SvgTake = function SvgTake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "message",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/take.b204c1cb.svg";
export { ForwardRef as ReactComponent };